import React from 'react'
import { useDroppable } from '@dnd-kit/core'

function Droppable({ id, children, data, setOverStyle = () => {} }) {
  const { setNodeRef, isOver, over } = useDroppable({
    id,
    data,
  })

  return (
    <div ref={setNodeRef} css={setOverStyle(isOver, over)}>
      {children}
    </div>
  )
}

export default Droppable
